/**
 * Click-to-load video player for every ds-* video frame on the site.
 *
 * This lives in a shared asset, not in a section's inline <script>. The player
 * behaviour used to sit inside main-course.liquid, so a frame rendered on the
 * homepage had markup and data but no handler: the play button was inert. Any
 * template that renders a frame now gets working playback for free.
 *
 * Frames opt in with [data-ds-video]:
 *   data-mp4-1080 / -720 / -480  Shopify-hosted sources, preferred
 *   data-video-id                YouTube id, used only when no file exists
 *   data-poster                  still shown by the <video> before it plays
 *
 * Delegated from the document, so frames added after load still work.
 */
(function () {
  var SELECTOR = '[data-ds-video], [data-ds-trailer]';
  var PLAY = '[data-ds-video-play], [data-ds-trailer-play]';

  function hostedSources(frame) {
    var out = [];
    ['1080', '720', '480'].forEach(function (h) {
      var u = frame.getAttribute('data-mp4-' + h);
      if (u) out.push(u);
    });
    return out;
  }

  function play(frame) {
    if (frame.getAttribute('data-ds-played') === 'true') return;
    var sources = hostedSources(frame);

    if (sources.length) {
      var v = document.createElement('video');
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.preload = 'auto';
      v.className = 'ds-video-frame__player';
      var poster = frame.getAttribute('data-poster');
      if (poster) v.poster = poster;
      sources.forEach(function (u) {
        var s = document.createElement('source');
        s.src = u;
        s.type = 'video/mp4';
        v.appendChild(s);
      });
      frame.replaceChildren(v);
      frame.setAttribute('data-ds-played', 'true');
      return;
    }

    var id = frame.getAttribute('data-video-id');
    if (!id) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = frame.getAttribute('data-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.className = 'ds-video-frame__player';
    frame.replaceChildren(iframe);
    frame.setAttribute('data-ds-played', 'true');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(PLAY);
    if (!button) return;
    var frame = button.closest(SELECTOR);
    if (!frame) return;
    event.preventDefault();
    play(frame);
  });
})();
